export default __webpack_public_path__ + "static/media/icon-notes.ea192664.svg";